import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useEventUuidParam = () => {
	const { id, uuid } = useParams<{ id: string; uuid?: string; }>();
	return useMemo(() => uuid ?? id, [id, uuid]);
};

export const useEventUuidParamModerator = () => {
	const { event_uuid } = useParams<{ event_uuid: string }>();
	return useMemo(() => event_uuid, [event_uuid]);
};
